// extracted by mini-css-extract-plugin
export default {"root":"MainContent_root__RYPAm"};